import { createContext, useContext } from "react";

import { ILanguageState } from "providers/LanguageProvider";

const LanguageContext = createContext<ILanguageState>({} as ILanguageState);

export const useLanguageState = () => {
	const state = useContext(LanguageContext);

	if (!Object.keys(state).length)
		throw new Error("State is empty or hook useLanguageState is not in LanguageContext provider!");

	return state;
};

export default LanguageContext;
